import { styled } from '@mui/material/styles';

export const ScrollContainer = styled('div')(({ theme }) => ({
  height: '75rem',

  backgroundColor: theme.colors.base07,
  border: `0.1rem solid ${theme.colors.base05}`,
  borderRadius: '2rem',
  display: 'flex',
  flexDirection: 'column',

  padding: '4rem 0',

  '*::webkit-scrollbar': {
    backgroundColor: 'transparent',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: theme.colors.base04,
  },
  '*::-webkit-scrollbar-corner': {
    backgroundColor: 'transparent',
  },
}));

export const Container = styled('div')(({ theme }) => ({
  maxHeight: '67rem',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  overflow: 'auto',

  '*::-webkit-scrollbar': {
    width: '0.2rem !important',
    backgroundColor: 'transparent',
    boderRadius: '0.1rem',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: theme.colors.base01,
  },
  '*::-webkit-scrollbar-corner': {
    backgroundColor: 'transparent',
  },
}));
